import React, { useEffect } from "react";
import { Header, Footer } from "./components";

import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/scss/webapp.scss";

import { gaTracking } from "./config";
import { useLocation } from "react-router-dom";
let ReactGA;
if (typeof window !== "undefined") {
  ReactGA = require("react-ga4").default;
}

if (typeof window !== "undefined") {
  ReactGA.initialize(gaTracking);
}

const App = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    setTimeout(() => {
      const header = document.getElementById("banner-present");
      const banner = document.querySelector(".banner");

      if (banner) {
        if (header) {
          banner.classList.add("banner-exists");
        } else {
          banner.classList.remove("banner-exits");
        }
      }
    }, 1000);
 
  }
);

  return (
    <div className="app d-flex flex-column" id="app">
      <Header />
      <main id="main-content">{props.children}</main>
      <Footer />
    </div>
  );
};

export default App;
